module.exports = __webpack_public_path__ + "img/logo.a16d10bd.png";